import { get } from '@/request';

const profileApi = {
  one(data) {
    return get('/gt/profile/selectByProfileCode', data);
  }
};
export default profileApi;
